import { request } from '@umijs/max'
import { BPIAM_API, MARKETING_API } from '@/constants/API';

// 获取企业管理员
export async function rolesList(id: string | number) {
  return request(`${BPIAM_API}/role/rolesListById/${id}`);
}

//查询用户是否已勾选
export async function getUserState() {
  return request(`${MARKETING_API}/user/login/getUserState${process.env.appId ? `/${process.env.appId}` : ''}`);
}

//判断当前用户有没有可用助手 
export async function userHaveAssistant() {
  return request(`${MARKETING_API}/user/login/userHaveAssistant${process.env.appId ? `/${process.env.appId}` : ''}`);
}

// 用户勾选
export async function userState() {
  return request(`${MARKETING_API}/user/login/userState${process.env.appId ? `/${process.env.appId}` : ''}`);
}

// export async function update (params) {
//   return request(`${APP_MGMT}/modify`, {
//     method: 'POST',
//     data: {
//       ...params,
//     },
//   });
// }
// export async function del (appKey) {
//   return request(`${APP_MGMT}/del/?id=${appKey}`);
// }
